<chart style="height: 600px; width: 1500px;"
       [type]="chartData.type"
       [datasets]="chartData.data.datasets"
       [labels]="chartData.data.labels"
       [options]="chartData.options">
</chart>
